<template>
  <div class="bg-secondary-13 rounded my-3 pl-3 py-3 d-flex">
    <div class="col-12 col-md-2 left-info__container">
      <div>
        <div class="color-gray-6 font-14">
          Fecha:
        </div>
        <span>{{ date | dateTime }}</span>
      </div>
      <div class="mt-3">
        <div class="color-gray-6 font-14">
          Añadido por:
        </div>
        <span>{{ user }}</span>
      </div>
    </div>
    <div class="col-12 col-md-10">
      <div>
        <div class="color-gray-6 font-14">
          Comentario:
        </div>
        <span>{{ comment }}</span>
      </div>
      <div class="file-detail__container">
        <div class="d-flex">
          <div>
            <div class="color-gray-6 font-14">
              Nombre del Documento:
            </div>
            <span>{{ fileId ? fileAlias : '-' }}</span>
          </div>
          <div class="ml-5">
            <div class="color-gray-6 font-14">
              Archivo:
            </div>
            <span>{{ fileId ? filename : '-' }}</span>
          </div>
        </div>
        <div>
          <action-button
            class="action-button"
            class-icon="action-icon"
            :disabled="!fileId"
            i="fas fa-file-download"
            variant="success"
            @click="$emit('download', fileId)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BitacoraResultRow',
  props: {
    date: {
      type: String,
      default: null,
    },
    user: {
      type: String,
      default: null,
    },
    comment: {
      type: String,
      default: null,
    },
    fileAlias: {
      type: String,
      default: null,
    },
    filename: {
      type: String,
      default: null,
    },
    fileId: {
      type: String,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.left-info__container {
  border-right: 2px solid #efefef;
}

.file-detail__container {
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  padding: 10px 20px;
  background-color: #ffffff;
}
</style>
